const container = (tokens) => {
    const { mobile, tablet, desktop } = tokens.semantic.layout;
    return {
        MuiContainer: {
            styleOverrides: {
                root: ({ theme }) => ({
                    [theme.breakpoints.up("sm")]: {
                        paddingLeft: mobile.marginLeft.value,
                        paddingRight: mobile.marginRight.value,
                    },
                    [theme.breakpoints.up("md")]: {
                        paddingLeft: tablet.marginLeft.value,
                        paddingRight: tablet.marginRight.value,
                    },
                    [theme.breakpoints.up("lg")]: {
                        paddingLeft: desktop.marginLeft.value,
                        paddingRight: desktop.marginRight.value,
                    },
                }),
                maxWidthLg: ({ theme }) => ({
                    [theme.breakpoints.up("lg")]: {
                        maxWidth: `calc(${desktop.maxWidth.value} + ${desktop.marginLeft.value} + ${desktop.marginRight.value})`,
                    },
                }),
            },
        },
    };
};
export default container;
//# sourceMappingURL=container.js.map